export default {
  id: 135,
  title: 'Target #135 - Spikes',
  url: 'https://cssbattle.dev/play/135',
  colors: ['#E3516E', '#D9D9D9'],
  solution:
    '<a a><a b><style>[b],body{background:#e3516e}a{position:fixed}[a]{top:100;left:0;width:190;height:40;background:#d9d9d9;border-radius:9in;box-shadow:0 60px #d9d9d9,210px 0 #d9d9d9,210px 60px #d9d9d9}[b]{top:0;left:19;width:212;height:212;transform-origin:top left;transform:rotate(45deg);box-shadow:256px -256px #e3516e}</style>',
}
